import { Sounds } from './sounds';
import { VehicleSounds } from './game/vehicle/Vehicle';
import Track = Sounds.Track;

export namespace SoundBanks {
  export const buildVehicleSounds = (character: Sounds.CharacterValues): VehicleSounds => {
    return {
      engine: 'Snd' + character + Sounds.Partial.EngineLoop + '1',
      engineRef: '',
      boost: 'Snd' + character + Sounds.Partial.Boost + '1',

      hit: 'Snd' + character + Sounds.Partial.Hit + '1',
      fire: 'Snd' + character + Sounds.Partial.Fire + '1',
      punch: 'Snd' + character + Sounds.Partial.Punch + '1',
      prefire: 'Snd' + character + Sounds.Partial.PreFire + '1',
      villainVoice: 'Snd' + character + Sounds.Partial.Caught + '1',
      // caught: 'Snd' + character + Sounds.Partial.Caught + '1',
      cheer: 'Snd' + character + Sounds.Partial.Cheer + 1,
      whoa: 'Snd' + character + Sounds.Partial.Whoa
    };
  };

  export const MoneyThrow: string[] = [Track.Throw1, Track.Throw2, Track.Throw3];
}
